import {Type} from "bukku/redux/Transaction/helper";

const options = {
    [Type.sale_invoice]: {
        view: true,
        duplicate: true,
        copyToRecurring: true,
        addPayment: true,
        copyItemsToPurchaseOrder: true,
        copyItemsToGoodsReceivedNote: true,
        copyItemsToBill: true,
        copyToSaleCreditNote: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
        combinePrint: true,
    },
    [Type.sale_credit_note]: {
        view: true,
        duplicate: true,
        print: true,
        share: true,
        sendEmail: true,
        addPayment: true,
        status: true,
    },
    [Type.opening_invoice]: {
        view: true,
        addPayment: true,
    },
    [Type.opening_sale_credit_note]: {
        view: true,
        addPayment: true,
    },
    [Type.sale_order]: {
        view: true,
        duplicate: true,
        copyItemsToPurchaseOrder: true,
        transferToInvoice: true,
        transferToDeliveryOrder: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.sale_delivery_order]: {
        view: true,
        duplicate: true,
        transferToInvoice: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.sale_payment]: {
        view: true,
        duplicate: true,
        print: true,
        share: true,
        addPayment: true,
        sendEmail: true,
        status: true,
    },
    [Type.sale_refund]: {
        view: true,
        duplicate: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.sale_quote]: {
        view: true,
        duplicate: true,
        transferToInvoice: true,
        transferToDeliveryOrder: true,
        transferToOrder: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.purchase_order]: {
        view: true,
        duplicate: true,
        transferToGoodsReceivedNote: true,
        transferToBill: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.purchase_goods_received_note]: {
        view: true,
        duplicate: true,
        transferToBill: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.purchase_bill]: {
        view: true,
        duplicate: true,
        copyToRecurring: true,
        copyToPurchaseCreditNote: true,
        addPayment: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.purchase_credit_note]: {
        view: true,
        duplicate: true,
        print: true,
        share: true,
        sendEmail: true,
        addPayment: true,
        status: true,
    },
    [Type.purchase_payment]: {
        view: true,
        duplicate: true,
        print: true,
        addPayment: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.purchase_refund]: {
        view: true,
        duplicate: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.opening_bill]: {
        view: true,
        addPayment: true,
    },
    [Type.opening_purchase_credit_note]: {
        view: true,
        addPayment: true,
    },
    [Type.bank_income]: {
        view: true,
        duplicate: true,
        copyToRecurring: true,
        print: true,
        share: true,
        sendEmail: true,
        status: true,
    },
    [Type.bank_expense]: {
        view: true,
        duplicate: true,
        copyToRecurring: true,
        share: true,
        sendEmail: true,
        print: true,
        status: true,
    },
    [Type.bank_transfer]: {
        view: true,
        duplicate: true,
        copyToRecurring: true,
        print: true,
        status: true,
    },
    [Type.stock_adjustment]: {
        view: true,
        duplicate: true,
        print: true,
        status: true,
    },
    [Type.stock_transfer]: {
        view: true,
        duplicate: true,
        print: true,
        status: true,
    },
    [Type.journal_entry]: {
        view: true,
        duplicate: true,
        copyToRecurring: true,
        print: true,
        status: true,
    },
    [Type.contra]: {
        view: true,
        duplicate: true,
        print: true,
        status: true,
    },
    [Type.tax_deemed_payment]: {
        view: true,
        // duplicate: true,
        // print: true,
        status: true,
    },
};

export function getOptions(type) {
    return options[type];
}
